import {
  Alert,
  AlertTitle,
  AlertDescription,
} from '@anytimefitness/pb-react-ui'
import { AlertCircleIcon } from 'lucide-react'
import { type ServerActionResponse } from '@/types/types'

interface ActionsErrorProps<T> {
  state: ServerActionResponse<T>
  className?: string
}

export default function ActionsError<T>({
  state,
  className,
}: ActionsErrorProps<T>) {
  if (!state?.error && !state?.validationError) {
    return null
  }

  const { error, validationError } = state

  const validationErrorsList = validationError?.fieldErrors
    ? Object.values(validationError.fieldErrors).flat()
    : null

  return (
    <Alert variant="destructive" className={className}>
      <AlertCircleIcon />
      <AlertTitle>An error occurred.</AlertTitle>
      {!!error && <AlertDescription>{error}</AlertDescription>}
      {validationErrorsList && (
        <AlertDescription>
          Information added was not valid:
          <ul className="list-inside list-disc text-sm">
            {validationErrorsList.map((err, i) => (
              <li key={i}>{err}</li>
            ))}
          </ul>
        </AlertDescription>
      )}
    </Alert>
  )
}
